/**
 * @ngInject
 */

function facebookShare () {
    function link (scope, elem, attrs) {

        var leftPosition, topPosition;
        var socialWindowWidthFb = 626;
        var socialWindowHeightFb = 436;
        leftPosition = (window.screen.width / 2) - ((socialWindowWidthFb / 2) + 10);
        topPosition = 200;
        var windowFeaturesFb = "status=no,height=" + socialWindowHeightFb + ",width=" + socialWindowWidthFb + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";

        elem[0].addEventListener('click', function(event){
            if(attrs.facebookShare == "") attrs.facebookShare = window.location.href;
            window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(attrs.facebookShare) + "", "facebook", windowFeaturesFb);
        });
    }

    return {
        restrict : 'A',
        link : link
    };
}